import { lazy } from 'react';

export const InventoryPage = lazy(() =>
  import('@/features/inventory/InventoryPage').then((module) => ({
    default: module.InventoryPage,
  })),
);

export const MaterialImportPage = lazy(() =>
  import('@/features/inventory/MaterialImportPage').then((module) => ({
    default: module.MaterialImportPage,
  })),
);

export const CountSheetPage = lazy(() =>
  import('@/features/inventory/CountSheetPage').then((module) => ({
    default: module.CountSheetPage,
  })),
);

export const INVENTORY_CHILD_ROUTES = {
  inventory: [
    // Declared before ':id' so that /inventory/import and /inventory/count are
    // their own screens rather than a material whose identifier happens to be
    // "import" or "count".
    { path: 'import', element: MaterialImportPage, permission: 'INVENTORY_ADJUST' },
    { path: 'count', element: CountSheetPage, permission: 'INVENTORY_ADJUST' },
    { path: ':id', element: InventoryPage },
  ],
};
